var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-circular-icon-button',_vm._g({attrs:{"big":"","icon":_vm.iconName,"customBackgroundColors":_vm.bgColorClass,"customIconColors":_vm.iconColorClass}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }